module.exports = __webpack_public_path__ + "static/media/stage_tips_image.8118880d.png";